<template>
  <tr>
    <td>
      {{ item.date | short_date_format }}
    </td>
    <td>
      {{ item.type }}
    </td>
    <td>
      <router-link v-if="item.charge && item.charge.Reservation" :to="'/fleet/reservations/' + item.charge.Reservation.uuid">
        {{ item.description }}
      </router-link>
      <router-link v-else-if="item.charge && item.charge.Reservations && isFinanceAdmin" :to="'/membership/members/billing/preauth/' + item.charge.uuid">
        {{ item.description }}
      </router-link>
      <span v-else>
        {{ item.description }}
      </span>
    </td>
    <td>
      <span :class="'badge badge-' + item.status.labelType">
        {{ item.status.labelText }}
      </span>
    </td>
    <td>
      {{ item.debit | to_dollar_amount }}
    </td>
    <td>
      {{ item.credit | to_dollar_amount }}
    </td>
    <td>
      {{ item.balance | to_dollar_amount_neg }}
    </td>
    <td>
      <template v-if="isFinanceAdmin">
        <router-link v-if="captureButton" class="btn btn-sm btn-amber" :to="'/membership/members/billing/preauth/' + item.charge.uuid">
          <span class="fa fa-hand-rock fa-fw"></span> Capture
        </router-link>
        <button v-else-if="refundButton" @click="refund(item.charge)" class="btn btn-sm btn-success">
          <span class="fa fa-exchange-alt fa-fw"></span> Refund
        </button>
        <button v-else-if="cancelButton" @click="refundPending(item.charge)" class="btn btn-sm btn-danger">
          <span class="fa fa-ban fa-fw"></span> Cancel
        </button>
      </template>
    </td>
  </tr>
</template>

<script>
import {
  REFUND_CHARGE,
  REFUND_PENDING_CHARGE
} from '@/vuex/types'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'LedgerRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    captureButton () {
      return this.item.charge.Reservations && !this.item.charge.captured &&
      !parseFloat(this.item.charge.refunded)
    },
    refundButton () {
      return !this.item.charge.refunded && (this.item.charge.Reservation ||
        this.item.charge.charges || this.item.modelName === 'CreditCharge') &&
        (this.item.type !== 'Sale' || this.item.modelName === 'CreditCharge')
    },
    cancelButton () {
      return this.item.charge.pending
    },
    item () {
      return {
        ...this.object,
        ...this.updatedItem
      }
    },
    ...mapGetters([
      'isFinanceAdmin'
    ])
  },
  data () {
    return {
      updatedItem: {}
    }
  },
  methods: {
    async executeAction (action, payload) {
      let result = await this[action](payload)
      if (result && result.updated) this.updatedItem = result.updated
    },
    refund (charge) {
      this.executeAction(REFUND_CHARGE, {
        ChargeUuid: charge.uuid,
        AccountUuid: this.$route.params.account_id,
        modelName: this.item.modelName
      })
    },
    refundPending (charge) {
      this.executeAction(REFUND_PENDING_CHARGE, {
        ChargeUuid: charge.uuid,
        AccountUuid: this.$route.params.account_id,
        modelName: this.item.modelName
      })
    },
    ...mapActions([
      REFUND_CHARGE,
      REFUND_PENDING_CHARGE
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/Ledger.vue